/**
 * Читает число слева до первого недопустимого символа. Вычищать чужие символы
 * нельзя: «1e5» склеилось бы в «15» — обрезанное пользователь заметит,
 * подменённое число нет. Минус не поддерживается.
 *
 * Десятичный разделитель — последний из «.» и «,», поэтому «1 234,56»
 * и «1,234.56» читаются одинаково верно.
 */
export const toNumeric = (value: string, decimals: number): string => {
  // Пробелы разделяют тысячи в любой скопированной сумме
  const withoutSpaces = value.replace(/[\s\u00A0]/g, '');

  const lastComma = withoutSpaces.lastIndexOf(',');
  const lastDot = withoutSpaces.lastIndexOf('.');
  const hasBoth = lastComma !== -1 && lastDot !== -1;

  const decimalMark = lastComma > lastDot ? ',' : '.';
  const thousandsMark = decimalMark === ',' ? '.' : ',';

  const normalized = (
    hasBoth ? withoutSpaces.split(thousandsMark).join('') : withoutSpaces
  ).replace(',', '.');

  const matched =
    normalized.match(decimals > 0 ? /^\d*(?:\.\d*)?/ : /^\d*/)?.[0] ?? '';

  if (decimals <= 0) {
    return matched;
  }

  const [whole, fraction] = matched.split('.');

  return fraction === undefined
    ? whole
    : `${whole}.${fraction.slice(0, decimals)}`;
};
